import { BlockConfig as BlockConfigV1 } from '../version1/BlockConfig.types';
import { BlockType, FieldType, ImageSize } from './Types';
import { BlockConfig as BlockConfigV2 } from './BlockConfig.types';
import { NavBarBlockConfig } from './NavBarConfig.types';
import { TestimonialBlockConfig } from './TestimonialConfig.types';
import { NaiveBookMeetingBlockConfig } from './NaiveBookMeetingConfig.types';
import { LogoBarBlockConfig } from './LogoBarConfig.types';
import { CTALayout } from './CTAConfig.types';
import { CardIconMode } from './ValuePropConfig.types';

export function migrateToV2(blockConfig: BlockConfigV1): BlockConfigV2 {
  switch (blockConfig.type) {
    case BlockType.Hero: {
      const [fieldGroup] = blockConfig.fieldGroups;
      return { ...blockConfig, fieldGroups: [fieldGroup], version: 2 };
    }
    case BlockType.Cta: {
      const { options, ...rest } = blockConfig;
      const [fieldGroup] = blockConfig.fieldGroups;
      return {
        ...rest,
        options: { ...options, layout: options.layout === 'standard' ? CTALayout.Center : options.layout },
        fieldGroups: [fieldGroup],
        version: 2,
      };
    }
    case BlockType.NavBar: {
      const [fieldGroup] = blockConfig.fieldGroups;
      const fieldGroups: NavBarBlockConfig['fieldGroups'] = [
        {
          ...fieldGroup,
          fields: fieldGroup.fields.map((field) =>
            field.type === FieldType.ImageSize
              ? {
                  ...field,
                  defaultValue: field.defaultValue === '' ? ImageSize.Medium : field.defaultValue,
                }
              : field,
          ),
        },
      ];
      return { ...blockConfig, fieldGroups, version: 2 };
    }
    case BlockType.LogoBar: {
      const [logoBarHeaderFieldGroup, ...logoBarLogoFieldGroups] = blockConfig.fieldGroups;
      const fieldGroups: LogoBarBlockConfig['fieldGroups'] = [
        logoBarHeaderFieldGroup,
        ...logoBarLogoFieldGroups.map((fieldGroup) => ({
          ...fieldGroup,
          fields: fieldGroup.fields.map((field) =>
            field.type === FieldType.ImageSize
              ? {
                  ...field,
                  defaultValue: field.defaultValue === '' ? ImageSize.Medium : field.defaultValue,
                }
              : field,
          ),
        })),
      ];
      return { ...blockConfig, fieldGroups, version: 2 };
    }
    case BlockType.Testimonial: {
      const [fieldGroup, ...moreFieldGroups] = blockConfig.fieldGroups;
      const fieldGroups: TestimonialBlockConfig['fieldGroups'] = [
        {
          ...fieldGroup,
          fields: fieldGroup.fields.map((field) =>
            field.type === FieldType.ImageSize
              ? {
                  ...field,
                  defaultValue: field.defaultValue === '' ? ImageSize.Medium : field.defaultValue,
                }
              : field,
          ),
        },
        ...moreFieldGroups.map((group) => ({
          ...group,
          fields: group.fields.map((field) =>
            field.type === FieldType.ImageSize
              ? {
                  ...field,
                  defaultValue: field.defaultValue === '' ? ImageSize.Medium : field.defaultValue,
                }
              : field,
          ),
        })),
      ];
      return { ...blockConfig, fieldGroups, version: 2 };
    }
    case BlockType.NaiveBookMeeting: {
      const [fieldGroup] = blockConfig.fieldGroups;
      const fieldGroups: NaiveBookMeetingBlockConfig['fieldGroups'] = [
        {
          ...fieldGroup,
          fields: fieldGroup.fields.map((field) =>
            field.type === FieldType.ImageSize
              ? {
                  ...field,
                  defaultValue: field.defaultValue === '' ? ImageSize.Medium : field.defaultValue,
                }
              : field,
          ),
        },
      ];
      return { ...blockConfig, fieldGroups, version: 2 };
    }
    case BlockType.ValueProp: {
      const {
        options: { cardIconMode, ...options },
        ...rest
      } = blockConfig;
      return {
        ...rest,
        options: { ...options, cardIconMode: cardIconMode === '' ? CardIconMode.None : cardIconMode },
        version: 2,
      };
    }
    default: {
      return { ...blockConfig, version: 2 } as BlockConfigV2;
    }
  }
}
